import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Portal from "../Modal/Portal";

import { Background, Overlay } from "./styles";
import TooltipPopover from "./TooltipPopover";

const Popper = ({
  isOpen = false,
  onClose = null,
  selector = "#root",
  anchorRef = null,
  children,
  addHalf = true,
  width = 0,
  height = 0,
  setMarkerPosition,
  markerSize = 15,
}) => {
  const [coords, setCoords] = useState({});

  useEffect(() => {
    if (isOpen) {
      updateTooltipCoords();
    }
    window.addEventListener("resize", updateTooltipCoords);
    return () => window.removeEventListener("resize", updateTooltipCoords);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const updateTooltipCoords = () => {
    const anchorRect = anchorRef.current?.getBoundingClientRect();

    if (!anchorRect) {
      return;
    }
    let calculatedLeft = !addHalf
      ? anchorRect.left
      : anchorRect.left + anchorRect.width / 2;
    let calculatedTop = anchorRect.top + window.scrollY;
    let positionAbove = true;

    // Adjust the position if width and height are provided
    if (width && height) {
      calculatedLeft -= width / 2;

      // Check if there's enough space above the anchor for the popper
      const spaceAboveAnchor = anchorRect.top;
      const spaceBelowAnchor =
        window.innerHeight - (anchorRect.top + anchorRect.height);

      if (height + 30 <= spaceAboveAnchor) {
        // Position above the anchor with some space
        calculatedTop -= height + 30;
      } else if (height + 30 <= spaceBelowAnchor) {
        // Not enough space above, place below the anchor instead
        calculatedTop = anchorRect.bottom + window.scrollY + 30;
        positionAbove = false;
      } else {
        // If there's not enough space above or below, position it above without the extra space
        // This is a fallback, it will overlap the anchor
        calculatedTop -= height;
      }

      // Ensure the popper does not render off-screen horizontally
      if (calculatedLeft < 0) calculatedLeft = 0;
      if (calculatedLeft + width > window.innerWidth) {
        calculatedLeft = window.innerWidth - width;
      }
      const anchorCenter = anchorRect.left + anchorRect.width / 2;
      const arrowPosition =
        ((anchorCenter - calculatedLeft - markerSize) / width) * 100;
      const safeArrowPosition = Math.min(Math.max(arrowPosition, 10), 90);

      setMarkerPosition({ pos: `${safeArrowPosition}%`, above: positionAbove });
    }
    setCoords({
      left: calculatedLeft,
      top: calculatedTop,
    });
  };

  return (
    <>
      {isOpen && (
        <Portal selector={selector}>
          <Overlay id="popperContainer" isOpen={isOpen} className="nodrag">
            <Background onClick={onClose}>
              <TooltipPopover coords={coords}>{children}</TooltipPopover>
            </Background>
          </Overlay>
        </Portal>
      )}
    </>
  );
};
export default Popper;
